import { render, staticRenderFns } from "./FilterBar.vue?vue&type=template&id=20a2d456&scoped=true&"
import script from "./FilterBar.vue?vue&type=script&lang=js&"
export * from "./FilterBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a2d456",
  null
  
)

export default component.exports